"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(plugins) {
    let temp = [];
    Object.entries(plugins).forEach(([key, entry]) => {
        temp.push(entry.name);
    });
    return temp;
}
exports.default = default_1;
